import { connect } from 'react-redux';
import { RatingModal as RatingModalComponent } from '@shared/components/modals/ratingModal';
import { submitReview, updateReview, deleteReview } from '@shared/actions/thunkActions';
export const mapStateToProps = (state)=>{
    return {
        userInfo: state.users,
        reviewsData: state.apps.appReviewsData
    };
};
export const mapDispatchToProps = (dispatch)=>{
    return {
        submitReview: (reviewFormData)=>dispatch(submitReview(reviewFormData)),
        deleteReview: (reviewFormData)=>dispatch(deleteReview(reviewFormData)),
        updateReview: (reviewFormData)=>dispatch(updateReview(reviewFormData))
    };
};
export const RatingModal = connect(mapStateToProps, mapDispatchToProps)(RatingModalComponent);
